module.exports = __webpack_public_path__ + "assets/83d0ac379ad5b9678730910db4280de5.mp4";